import { render } from "./DraftModal.vue?vue&type=template&id=0038ae5a"
import script from "./DraftModal.vue?vue&type=script&lang=js"
export * from "./DraftModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__